<template>
  <div>
    <div class="comp_wrap" v-show="!showDetail">
      <div class="cont_title">
        病害预报列表
      </div>
      <div class="cont_view">
        <div class="cont_col" v-for="item in dataList" :key="item.id" @click="openDetail(item.id)">
          <div class="cont_col_title">
            {{ item.articleTitle }}
          </div>
          <div class="cont_col_at">
            {{ item.releaseTime.slice(0, 10) }}
          </div>
        </div>
      </div>
    </div>

    <div class="result_pop" v-if="showDetail">
      <div class="pop_panel">
        <div class="pop_close" @click="showDetail = false">
          <i class="el-input__icon el-icon-close"></i>
        </div>

        <div class="pop_title">
          {{ detailInfo ? detailInfo.articleTitle : '' }}
        </div>

        <div class="pop_cont">
          <div v-html="detailInfo ? detailInfo.articleContent : ''">
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'disease-forecast',
  data() {
    return {
      dataList: [],
      showDetail: false,
      detailInfo: null,
    }
  },
  computed: {},
  methods: {
    openDetail(id) {
      this.detailInfo = null
      
      this.$axios('/ufish-diagnosis/app/articles/' + id).then((r) => {
        if (r.code === '00000') {
          this.detailInfo = r.data
          this.showDetail = true
        }
      })
    }
  },
  components: {},
  beforeMount() {
    // 模板编译/挂载之前
    const params = {
      page: 1,
      pageSize: 999999999,
      param: {}
    }
    this.$axios({
      url: '/ufish-diagnosis/app/articles/queryArticlePage',
      method: 'post',
      data: params
    }).then((r) => {
      if (r.code === '00000') {
        this.dataList = r.data.list
      }
    })
  },
  mounted() {
    // 模板编译/挂载之后
  },
  beforeUpdate() {
    // 组件更新之前
  },
  updated() {
    // 组件更新之后
  },
  beforeDestroy() {
    // 组件销毁前调用
  },
  destroyed() {
    // 组件销毁后调用
    // Tips：当前组件已被删除，清空相关内容
  },
}
</script>
<style lang="less" scoped>
.comp_wrap {
  width: 100%;
  height: 750px;
  padding: 30px;
  box-sizing: border-box;
  background: #f9f8f4;
  .cont_title {
    width: 100%;
    position: relative;
    font-size: 20px;
    padding-left: 13px;
    line-height: 1;
    &:after {
      content: '';
      position: absolute;
      width: 6px;
      height: 20px;
      left: 0;
      top: 50%;
      transform: translateY(-50%);
      background: linear-gradient(0deg, #fe69fb 0%, #089ddd 50%, #6be0bd 100%);
    }
  }
  .cont_view {
    width: 100%;
    margin-top: 20px;
    height: calc(100% - 40px);
    overflow-y: auto;
    /* 自定义滚动条整体样式 */
    &::-webkit-scrollbar {
      width: 6px;
      height: 6px;
      background-color: rgba(255, 255, 255, .1);
    }
    
    /* 自定义滚动条滑块样式 */
    &::-webkit-scrollbar-thumb {
      width: 6px;
      height: 6px;
      background-color: rgba(255, 255, 255, .3);
      border-radius: 6px;
    }
    .cont_col {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 20px;
      box-sizing: border-box;
      padding: 20px 30px;
      cursor: pointer;
      background: #fff;
      .cont_col_title {
        font-size: 18px;
        width: 756px;
        line-height: 30px;
      }
      .cont_col_at {
        font-size: 18px;
        color: #fff;
      }
    }
  }

  .detail_crumbs {
    display: flex;
    justify-content: space-between;
    align-items: center;
    .detail_crumbs_l {
      width: 1px;
      flex: 1;
      text-overflow: ellipsis;
      white-space: nowrap;
      overflow: hidden;
      font-size: 15px;
      line-height: 1;
    }
    .detail_crumbs_r {
      display: flex;
      align-items: center;
      font-size: 15px;
      line-height: 1;
      cursor: pointer;
      img {
        width: 24px;
        margin-left: 15px;
      }
    }
  }
  .detail_view {
    width: 100%;
    height: calc(100% - 44px);
    margin-top: 20px;
    box-sizing: border-box;
    padding: 20px 28px;
    overflow-y: auto;
    /* 自定义滚动条整体样式 */
    &::-webkit-scrollbar {
      width: 6px;
      height: 6px;
      background-color: rgba(255, 255, 255, .1);
    }
    
    /* 自定义滚动条滑块样式 */
    &::-webkit-scrollbar-thumb {
      width: 6px;
      height: 6px;
      background-color: rgba(255, 255, 255, .3);
      border-radius: 6px;
    }
    
    .detail_title {
      font-size: 22px;
      line-height: 30px;
      text-align: center;
    }
    .detail_tar {
      display: flex;
      align-items: center;
      margin-top: 30px;
      border-bottom: 1px solid #46494A;
      padding-bottom: 8px;
      > span {
        margin-right: 30px;
        font-size: 16px;
        line-height: 30px;
        &:nth-of-type(2) {
          flex: 1;
          width: 1px;
        }
        &:last-of-type {
          margin-right: 0;
        }
      }
    }
    .detail_cont {
      padding: 30px 0;
      img {
        max-width: 100%;
        height: auto !important;
      }
    }

  }
}


.result_pop {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, .5);
  z-index: 14;
  .pop_panel {
    width: 1140px;
    height: 700px;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    background: #fff;
    box-sizing: border-box;
    padding: 30px;
    .pop_close {
      position: absolute;
      right: 23px;
      top: 23px;
      width: 16px;
      cursor: pointer;
      z-index: 15;
      i {
        font-size: 20px;
      }
    }
    .pop_title {
      width: 100%;
      position: relative;
      font-size: 22px;
      padding-left: 13px;
      line-height: 1;
      &:after {
        content: '';
        position: absolute;
        width: 6px;
        height: 20px;
        left: 0;
        top: 50%;
        transform: translateY(-50%);
         background: linear-gradient(0deg, #fe69fb 0%, #089ddd 50%, #6be0bd 100%);
      }
    }

    .pop_result_inner {
      width: 100%;
      height: calc(100% - 60px);
      box-sizing: border-box;
      margin-top: 30px;
      overflow-y: auto;
      display: flex;
      flex-wrap: wrap;
      /* 自定义滚动条整体样式 */
      &::-webkit-scrollbar {
        width: 6px;
        height: 6px;
        background-color: rgba(0, 0, 0, .05);
      }
      
      /* 自定义滚动条滑块样式 */
      &::-webkit-scrollbar-thumb {
        width: 6px;
        height: 6px;
        background-color: rgba(0, 0, 0, .1);
        border-radius: 6px;
      }

      .pop_result_col {
        width: 486px;
        height: 281px;
        background: #f7f7fb;
        margin-right: 34px;
        box-sizing: border-box;
        padding-top: 65px;
        padding-left: 67px;
        position: relative;
        &:nth-child(2n) {
          margin-right: 0;
          margin-bottom: 34px;
        }
        > h5 {
          font-size: 22px;
          line-height: 1;
          text-overflow: ellipsis;
          white-space: nowrap;
          overflow: hidden;
          font-weight: 500;
        }
        > span {
          font-size: 16px;
          color: #666666;
          line-height: 1;
          margin-top: 75px;
          display: block;
        }
        > p {
          font-size: 40px;
          line-height: 1;
          margin-top: 15px;
        }
        .view_btn {
          position: absolute;
          right: 115px;
          bottom: 50px;
          display: flex;
          align-items: center;
          font-size: 20px;
          line-height: 1;
          color: #1800FC;
          cursor: pointer;
          > img {
            width: 20px;
            margin-left: 3px;
          }
        }
      }
    }

    .pop_cont {
      width: 1006px;
      margin-left: 14px;
      margin-top: 30px;
      background: #F7F7FB;
      box-sizing: border-box;
      height: calc(100% - 60px);
      padding: 50px;
      > div {
        width: 100%;
        height: 100%;
        overflow-y: auto;
        font-size: 20px;
        /* 自定义滚动条整体样式 */
        &::-webkit-scrollbar {
          width: 6px;
          height: 6px;
          background-color: rgba(0, 0, 0, .05);
        }
        
        /* 自定义滚动条滑块样式 */
        &::-webkit-scrollbar-thumb {
          width: 6px;
          height: 6px;
          background-color: rgba(0, 0, 0, .1);
          border-radius: 6px;
        }
        :deep(#app) {
          height: auto !important;
        }
      }
    }
  }
}
</style>
